import React, {useState} from "react";
import CustomCardContainer from "../../../../../components/CustomCardContainer";
import CustomCard from "../../../../../components/CustomCard";
import {
    DateTimePickerChip,
    IconCalendarStar,
    IconChipBell,
    IconInfoCard,
    IconLoading,
    MarkerTitle,
    PersonOutlinedChip
} from "../../../../../components/buttons/IconButtons";
import CustomUserChip from "../../../../../components/CustomUserChip";
import {status, STATUS_MODEL} from "../../../../../enums/statusEnum";
import {
    chipStatusClassColor,
    statusBorderColor,
    statusColor,
    statusFontColor
} from "../../../../../enums/statusColorEnum";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import {
    EMPTY_VALUES,
    getDateFormat,
    getFullName,
} from "../../../../../Apis/functions";
import CustomChip from "../../../../../components/CustomChip";
import {colors} from "../../../../../enums/colors";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import CustomTooltip from "../../../../../components/CustomTooltip";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import {CARDS_MODEL} from "../Model/Model";
import {IncomingInvitationBodyApp} from "../Functionality/IncomingInvitationBodyApp";
import routes from "../../../../../Routes/routes";
import {invitationInTime} from "../../Invitation/Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

const IncomingInvitationBody = ({ t, withSearchPendingToComplete, withSearchPendingValidation, withSearchReadyToEnter, withSearchCheckIn }) => {


    const {
        getVisitStatusTime,
        getUserStatus,
        handleNotify,
        columns,
        getInvitationDateText,
        getUserRestriction
    } = IncomingInvitationBodyApp({
        withSearchPendingToComplete, withSearchPendingValidation, withSearchReadyToEnter, withSearchCheckIn,t})


    return (
        <div className={"row flex-row flex-nowrap overflow-auto"}>
            {columns.map(column => (
                <div key={column.key} className={`col-3 w-100 minw-510px`}>
                    <CustomCardContainer cardContentClass={'h-80vh border-radius-12px background-shades-100'}>
                        <div className={"d-flex w-100 mb-2"}>
                            <p className={"d-flex w-100 gap-1"}>
                                <CustomGenericTittleIconDataChip
                                    Icon={column.icon} title={column.title} border={false}/>
                                <div className={"d-flex background-shades-200 border-full-shades-300 rounded-circle w-15px h-18px justify-content-center align-items-center"}>
                                    <span className={"fs-12px ibl-font-w-500 font-color-shades-500"}>{column.items.length}</span>
                                </div>
                            </p>
                            <CustomTooltip text={t(column.tooltip)}>
                                <IconInfoCard className={"icon-color-shades-500"} width={20} height={20} />
                            </CustomTooltip>
                        </div>
                        {column.items.map(invitation => {
                            const statusTime = getVisitStatusTime(invitation.startDate, invitation.endDate, invitation?.checkIn);
                            const identityValidationDenied = (getUserRestriction.validationVisitor && invitation.identityValidation === STATUS_MODEL.DENIED);
                            let statusChip;
                            let tooltipText = '';
                            const isOverdue = !invitationInTime(invitation.endDate);

                            if(identityValidationDenied){
                                statusChip = invitation.identityValidation;
                                tooltipText = 'identity_verification_rejected';
                            }else if (invitation?.statusId === STATUS_MODEL.REJECTED){
                                statusChip = invitation?.statusId;
                                tooltipText = "rejected_by_admin";
                            } else {
                                statusChip = invitation?.visitorStatusId;
                                tooltipText = statusChip === STATUS_MODEL.CANCELED ? "canceled_by_visitor" : "";
                            }

                            return (
                                <CustomCard key={invitation.id} classes={'mt-3 mb-3'}
                                            classCard={`${column.key === CARDS_MODEL.CHECKED_IN && 'container-overlay-shades-100'} card-border-8px p-16px`}
                                            classContent={`p-0 background-general-00`}>
                                    <div className={"row gap-3"}>
                                        <div className={"p-0 m-0 col-12"}>
                                            <div className={"d-flex align-items-center justify-content-between"}>
                                                <div className={"d-flex align-items-center gap-2 p-0 m-0"}>
                                                    <CustomUserChip
                                                        className={`m-0 ${statusTime.chip} h-22px p-0 MuiChip-px-6px border-radius-4px minh-22px`}
                                                        name={getDateFormat(invitation?.startDate,false, 'HH:mm') +
                                                        "-" + getDateFormat(invitation?.endDate,false, 'HH:mm') +
                                                        ", " + getInvitationDateText(invitation)}
                                                        showAvatar={true}
                                                        Icon={IconChipBell}
                                                        classNameIcon={`${statusTime.icon} mt-0 p-0`}
                                                        classNameText={'ibl-font-w-600 p-0'}
                                                        variant="large"
                                                        iconPosition={POSITION_MODEL.LEFT}
                                                    />
                                                    <CustomTooltip text={t(tooltipText)} placement={"top"}>
                                                        <span className={"d-flex"}>
                                                               <CustomUserChip
                                                                   className={`mt-0 pl-12px pr-12px MuiChip-px-6px border-radius-4px h-22px minh-22px ${chipStatusClassColor[statusChip]}`}
                                                                   name={t(status[statusChip]) || EMPTY_VALUES.DEFAULT}
                                                                   classNameText={'ibl-font-w-600 p-0'}
                                                                   variant="large"
                                                                   iconPosition={POSITION_MODEL.LEFT}
                                                               />
                                                        </span>
                                                    </CustomTooltip>

                                                </div>
                                                <CustomUserChip
                                                    className='mt-0 chip-shades-300-00 m-0 h-22px p-0 MuiChip-px-6px border-radius-4px minh-22px'
                                                    name={"+" + invitation.visitorNumber}
                                                    Icon={PersonOutlinedChip}
                                                    showAvatar={true}
                                                    classNameText={"ibl-font-w-600"}
                                                    variant="large"
                                                    iconPosition={POSITION_MODEL.LEFT}
                                                />
                                            </div>
                                        </div>

                                        <div className={"p-0 m-0 row col-12 justify-content-start"}>
                                            <div className={'p-0 m-0 col-2'}>
                                                <div className={"background-primary-100 p-8px maxw-44px border-radius-8px justify-content-center d-flex"}>
                                                    <IconCalendarStar />
                                                </div>
                                            </div>
                                            <div className={"p-0 m-0 col-10 d-flex flex-column justify-content-start gap-1"}>
                                                <div className={"flex-row gap-2"}>
                                                    <CustomTooltip
                                                        text={getFullName(invitation.visitorName, invitation.visitorLastName, invitation.visitorSecondLastName)}
                                                        classes={"text-capitalize font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-1-row"}
                                                        showIfTruncated={true}
                                                    />
                                                    {" | "}
                                                    <CustomChip
                                                        background={statusColor[getUserStatus(invitation.visitorUserStatusId)]}
                                                        borderColor={statusBorderColor[getUserStatus(invitation.visitorUserStatusId)]}
                                                        fontColor={statusFontColor[getUserStatus(invitation.visitorUserStatusId)]}
                                                        legend={t(status[getUserStatus(invitation.visitorUserStatusId)]) || EMPTY_VALUES.DEFAULT}
                                                        variant={'large'}
                                                    />
                                                </div>
                                                <p className={"text-capitalize font-color-general-950 ibl-font-w-400 fs-14px mb-2"}>
                                                    {t('host')} : {getFullName(invitation.hostName, invitation.hostLastName, invitation.hostSecondLastName)}
                                                </p>

                                                <div className="d-flex">
                                                    <div className={"d-flex align-items-center pr-2"}>
                                                        <MarkerTitle className={"icon-color-shades-500"} />
                                                    </div>

                                                    <div className={"flex-grow-1 minw-0"}>
                                                        <CustomTooltip
                                                            text={invitation?.breadcrumb?.map(e => e.name)?.join(' - ')}
                                                            classes={"font-color-shades-500 fs-14px text-ellipsis-1-row"}
                                                            showIfTruncated={true}
                                                            placement={"top"}
                                                        />
                                                    </div>
                                                </div>

                                                <div className={"w-100"}>
                                                    <CustomChip
                                                        background={colors.secondary100}
                                                        borderColor={colors.secondary150}
                                                        fontColor={colors.secondary700}
                                                        legend={invitation.visitorType?.name || EMPTY_VALUES.DEFAULT}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        { isOverdue &&
                                            <div className="p-0 m-0 col-12 w-100 d-flex align-items-center gap-1">
                                                <DateTimePickerChip className={"btn-icon-svg-24px"} />
                                                <p className="fs-14px ibl-font-w-400">{t('invitation_has_expired')}</p>
                                            </div>
                                        }

                                        {!identityValidationDenied && !isOverdue &&
                                            <>
                                                {(column.key === CARDS_MODEL.PENDING_TO_COMPLETE) && (
                                                    <div className="p-0 m-0 col-12 d-flex justify-content-center w-100">
                                                        <ButtonAction
                                                            id="btn_iib_pending_to_complete"
                                                            name={ column.buttonName }
                                                            className="btn-outlined-secondary-600-00 w-100"
                                                            splitName={false}
                                                            onClick={() =>  window.open(
                                                                routes.invitationDetails.invitation + invitation.id + "/" + invitation.visitorId,
                                                                "_blank"
                                                            )}
                                                        />
                                                    </div>
                                                )}
                                                { (column.key === CARDS_MODEL.READY_TO_ENTER) && (
                                                    <div className="p-0 m-0 col-12 d-flex justify-content-center w-100">
                                                        <ButtonAction
                                                            id="btn_iib_ready_to_enter"
                                                            name={column.buttonName}
                                                            className="btn-outlined-secondary-600-00 w-100"
                                                            splitName={false}
                                                            onClick={() => handleNotify(invitation.id)}
                                                        />
                                                    </div>
                                                )}
                                                { (column.key === CARDS_MODEL.PENDING_VALIDATION && invitation?.visitorStatusId !== STATUS_MODEL.CANCELED) && (
                                                    <>
                                                        {invitation?.statusId === STATUS_MODEL.CHANGES_REQUESTED ?
                                                            <div className="p-0 m-0 col-12 d-flex justify-content-center w-100">
                                                                <ButtonAction
                                                                    id="btn_iib_changes_requested"
                                                                    name={ "changes_requested" }
                                                                    className="btn-outlined-warning-600 w-100"
                                                                    splitName={false}
                                                                    onClick={() =>  window.open(
                                                                        routes.invitationDetails.invitation + invitation.id + "/" + invitation.visitorId,
                                                                        "_blank"
                                                                    )}
                                                                />
                                                            </div>
                                                            :
                                                            <div className="p-0 m-0 col-12 w-100 d-flex align-items-end gap-1">
                                                                { invitation?.statusId !== STATUS_MODEL.REJECTED &&
                                                                <>
                                                                    <IconLoading />
                                                                    <p className="fs-14px ibl-font-w-400">{t(column.buttonName)}</p>
                                                                </>
                                                                }
                                                            </div>
                                                        }
                                                    </>
                                                )}
                                            </>
                                        }
                                    </div>
                                </CustomCard>
                            )
                        })}
                    </CustomCardContainer>
                </div>
            ))}
        </div>
    );
};

export default IncomingInvitationBody;
